import $ from 'jquery';
import {loadFlightSearchCalendars} from "../components/datepicker";

$(() => {
    $(".airplane-switcher .tab-element").on('click', (e) => {
        if($(e.currentTarget).hasClass('active')) return false;
        $(e.currentTarget).parent().find('.tab-element').removeClass('active');
        $(e.currentTarget).addClass('active');

        $(".flight--schedule.fs").removeClass('active');
        $(".flight--schedule.fs." + $(e.currentTarget).data('target')).addClass('active');
        loadFlightSearchCalendars();
        return false;
    });
    $(document).on('click', ".fs__date-filter .fs__button", (e) => {
        if($(e.currentTarget).hasClass('active')) return false;
        $(e.currentTarget).parent().find('.fs__button').removeClass('active');
        $(e.currentTarget).addClass('active');

        $(e.currentTarget).closest('.flight--schedule').find('.fs__flights').hide();
        $(e.currentTarget).closest('.flight--schedule').find('.fs__flights').eq($(e.currentTarget).data('element')).show();
        return false;
    });
});
